import React, { useState } from "react";
import "../../assets/css/SalesTrend/SalesTrend.css";
import { API_BASE_URL } from "../../config/config.js";
import SalesTrendHeader from "../SalesTrendHeader.tsx";
import TabComponent from "./components/TabComponent.tsx";
import {
  useTokenFromQuery,
  useFetchUserDetails,
  getUserIdFromToken,
  useResetRefreshTime,
} from "../../utils/dashboardUtils.js";
import WorkHabitFilter from "./components/WorkHabitFilter";

function WorkHabitKpi() {
  const [refreshTime, setRefreshTime] = useState(null);
  const [userLoaction, setuserLocation] = useState(null);
  const [headerUsername, setheaderUsername] = useState(null);

  useTokenFromQuery("/app/kpi_leadership_dashboard");
  useFetchUserDetails(
    setuserLocation,
    setheaderUsername,
    setRefreshTime,
    API_BASE_URL,
    "WorkHabitKpi"
  );
  useResetRefreshTime(setRefreshTime);
  const user_id = getUserIdFromToken();
  return (
    <div className="sales-trend-dashboard">
      <div className="dashboard-container">
        <SalesTrendHeader
          title="KPI Dashboard"
          userName={headerUsername}
          location={userLoaction}
          refreshTime={refreshTime}
        />

        <div className="new-filter-bar-sticky">
          <WorkHabitFilter
            user_id={user_id}
            apiEndpoint="KpiSummary/KPISummary"
          />
        </div>
        <TabComponent />
      </div>
    </div>
  );
}

export default WorkHabitKpi;
